import { useSyncExternalStore } from 'react';
import { subscribe, getSnapshot } from '../api/connectivity';

// Retorna { browserOnline, backendReachable, isOffline }.
// Reativo: re-renderiza quando a rede do navegador cai/volta
// ou quando o backend deixa de responder / volta a responder.
export function useConnectivity() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
